import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { AuthUserService } from '../../services/auth-user.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    NgbModule,
    NgbNavModule,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  isAuthenticated$: Observable<boolean>;
  
  constructor(
    private authService: AuthService,
    public userService: AuthUserService
  ) {
      this.isAuthenticated$ = authService.isAuthenticated$;
  }

  get email(): string {
    return this.userService.email;
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }
}
